import React, {useEffect, useRef, useState} from "react";
import Box from "@mui/material/Box";
import {Button, Grid, IconButton} from "@mui/material";
import InputField from "../../components/InputField";
import {Delete, QuestionAnswer} from "@mui/icons-material";
import TableData from "../../components/TableData";
import {BASE_URL, BUSINESS} from "../../constants";
import {reportErrors} from "../../helpers";
import Form from "../../components/Form";
import AlertBar from "../../components/AlertBar";
import ModalPage from "../../components/ModalPage";
import ConfirmationDialog from "../../components/ConfirmationDialog";
import QuestionAnswerMap from "./QuestionAnswerMap";
import SelectField from "../../components/SelectField";

const questionTypeSelect = [
    {label: "Multiple Choice", value: "Radio"},
    {label: "Text", value: "text"},
];
export default function ReviewQuestion(props) {
    const form = useRef();
    const alert = useRef();
    const modal = useRef();
    const nameRef = useRef();
    const questionTypeRef = useRef();
    const businessTypeRef = useRef();
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [data, setData] = useState({total: 0, data: []});
    const [canSubmit, setCanSubmit] = useState(true);
    const [showProgress, setShowProgress] = useState(false);
    const [name, setName] = useState();
    const [questionType, setQuestionType] = useState();
    const [businessType, setBusinessType] = useState();

    useEffect(() => {
        loadData();
    }, [businessType]);
    const loadData = () => {
        let url = `${BASE_URL}api/review-question?data=data`;
        if (businessType) {
            url += `&businessType=${businessType}`;
        }
        window.axios
            .get(url)
            .then((response) => {
                setData(response.data.data)
            })
            .catch((error) => {
                reportErrors(alert.current, error);
            });
    };

    const ConfirmationModal = (message, action, item) => {
        let component = (<ConfirmationDialog
            message={message}
            handleClose={() => modal.current.hide()}
            handleOk={() => {
                modal.current.hide();
                if (action === "add") {
                    submit()
                } else {
                    remove(item);
                }
            }}
        />);
        modal.current.show('Confirmation', component, '40%');
    }

    const ReviewQuestionMapping = (items) => {
        let component = <QuestionAnswerMap item={items}/>;
        modal.current.show('Review Question Mapping', component, "45%");
    }

    const submit = () => {
        let data = {name, questionType, businessType}
        if (canSubmit && form.current.validate()) {
            setCanSubmit(false);
            alert.current.showProgress();
            window.axios
                .post(`${BASE_URL}api/review-question`, data)
                .then(response => {
                    alert.current.showSuccess("Added Successfully.");
                    setCanSubmit(true);
                    setTimeout(() => {
                        setName("");
                        setQuestionType("");
                        setBusinessType("");
                        loadData();
                    }, 1000)
                })
                .catch(error => {
                    setCanSubmit(true);
                    reportErrors(alert.current, error);
                });
        }
    }

    const remove = (item) => {
        alert.current.showProgress();
        window.axios
            .delete(`${BASE_URL}api/review-question/${item.questionId}`, {})
            .then(response => {
                alert.current.showSuccess("Removed Successfully.");
                setCanSubmit(true);
                setTimeout(() => {
                    loadData();
                }, 1000)
            })
            .catch(error => {
                setCanSubmit(true);
                reportErrors(alert.current, error);
            });
    }

    return (<Box>
        <AlertBar ref={alert}/>
        <Form ref={form}>
            <Grid container spacing={2}>
                <Grid item xs={7}>
                    <InputField
                        ref={nameRef}
                        required={true}
                        placeholder="Quastion"
                        type="text"
                        value={name}
                        onChange={(value) => setName(value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <SelectField
                        ref={questionTypeRef}
                        required={true}
                        placeholder="Select Type"
                        options={questionTypeSelect}
                        value={questionType}
                        onChange={(value) => setQuestionType(value)}
                    />
                </Grid>
                <Grid item xs={2}>
                    <SelectField
                        ref={businessTypeRef}
                        required={true}
                        placeholder="Business Type"
                        options={BUSINESS}
                        value={businessType}
                        onChange={(value) => setBusinessType(value)}
                    />
                </Grid>
                <Grid item xs={1}>
                    <Button
                        disabled={!canSubmit}
                        sx={{textTransform: "none"}}
                        disableElevation
                        size="medium"
                        variant="contained"
                        color="primary"
                        fullWidth={true}
                        onClick={() => ConfirmationModal("Are you sure you want to proceed?", "add")}
                    >
                        Add
                    </Button>
                </Grid>
            </Grid>
        </Form>
        <TableData
            showProgres={showProgress}
            url=""
            title="Review Questions"
            columns={[
                {id: 'name', label: 'Question', minWidth: "x-larger",},
                {id: 'questionType', label: 'Question Type', minWidth: "larger",},
                {
                    id: 'action',
                    label: 'Answer',
                    minWidth: "small",
                    disabled: true,
                    customerRender: true,
                    valueGetter: (item) => (
                        <IconButton
                            size="small"
                            onClick={() => ReviewQuestionMapping(item)}>
                            <QuestionAnswer/>
                        </IconButton>
                    )
                },
                {
                    id: 'action',
                    label: 'Action',
                    minWidth: "small",
                    disabled: true,
                    customerRender: true,
                    valueGetter: (item) => (
                        <IconButton size="small"
                                    onClick={() => ConfirmationModal("Are you sure you want to remove?", "delete", item)}><Delete/></IconButton>)
                },
            ]}
            page={page}
            perPage={rowsPerPage}
            rows={data}
            rowClick={true}
            rowFunction={(item) => {
            }}
        />
        <ModalPage ref={modal}/>
    </Box>);
}